// This file is automatically generated. Do not edit manually.

import { ProjectActivityView } from "src/api/generated/erp/db/types/tables/projectActivityView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalvosDeliveryTransportProjectActivitiesApi {
	export async function getTransportProjectActivities(args: {
		deliveryTransportId: number;
	}): Promise<Array<ProjectActivityView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/salvos/deliveryTransportProjectActivities/getTransportProjectActivities",
			method: "POST",
			data: {
				deliveryTransportId: args.deliveryTransportId,
			},
		});
		return response as Array<ProjectActivityView>;
	}
}
